import Vue from 'vue'
import Vuex from 'vuex'
import { SET_CLASSES, SET_EO_ID } from './mutations.types'
import { GET_CLASSES } from './actions.types'
import { GET_IS_OLD } from './getters.types'
import { ApiService } from '../common/api.service'
import { dateFunc } from '../mixins/common'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    eoId: false,
    classes: false
  },
  mutations: {
    [SET_EO_ID] (state, value) {
      state.eoId = value
    },
    [SET_CLASSES] (state, value) {
      state.classes = value
    }
  },
  actions: {
    [GET_CLASSES] ({ state, commit }) {
      commit(SET_CLASSES, [])
      return ApiService.query('/api/v3/classes/' + state.eoId)
    }
  },
  getters: {
    [GET_IS_OLD]: state => {
      if (typeof state.classes.date_updated !== 'undefined') {
        const dateUpdate = dateFunc.methods.dateFormat(state.classes.date_updated)
        const now = new Date()
        const res = Math.floor(dateFunc.methods.diffDates(now, dateUpdate))
        return res > 14
      } else return true
    }
  },
  modules: {
  }
})
